import { useMemo } from 'react';

import type { UserTrade } from '@/lib/api/speed';

import { findOpenTrade } from '../utils/activeTrades';

import { useActiveUserTrades } from './useActiveUserTrades';

/**
 * The live Open trade for `coin`, or null in demo mode / before a fill lands.
 * Shared by every surface that needs what the exchange is actually holding for
 * the charted position — triggers, size, oids.
 */
export function useOpenTradeForCoin(coin: string | null): UserTrade | null {
    const { data: activeTrades } = useActiveUserTrades();

    return useMemo(() => findOpenTrade(activeTrades, coin), [activeTrades, coin]);
}
